// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { IListFormVariant } from '~/utils/interface/variant';

export const schema = (t: TFunction): yup.ObjectSchema<IListFormVariant> => {
  return yup.object().shape({
    listVariant: yup.array().optional(),
  });
};

export const defaultValuesListFormVariant: IListFormVariant = {
  listVariant: [],
};
